//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowToggle",
    props: {
        checked: {
            default: false,
            type: Boolean,
        },
        htmlTag: {
            default: null,
            type: String,
        },
        id: {
            default: "",
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
        name: {
            default: "",
            type: String,
        },
    },
    data: () => ({
        value: "0",
    }),
    methods: {
        handleChange(e) {
            this.value = e.target.checked ? "1" : "0";
        },
    },
};
